import { render, staticRenderFns } from "./EventElectricityDetailsPage.vue?vue&type=template&id=52b93693&scoped=true"
import script from "./EventElectricityDetailsPage.vue?vue&type=script&lang=js"
export * from "./EventElectricityDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./EventElectricityDetailsPage.vue?vue&type=style&index=0&id=52b93693&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b93693",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
